import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M16.068 4c.424 0 .768.344.768.768v1.808a.768.768 0 1 1-1.537 0V4.768c0-.424.344-.768.769-.768ZM7.932 4c.425 0 .769.344.769.768v1.808a.768.768 0 0 1-1.537 0V4.768c0-.424.344-.768.768-.768ZM3.548 10.192c0-.424.344-.768.768-.768h15.368a.768.768 0 0 1 0 1.537H4.316a.768.768 0 0 1-.768-.769Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M3.548 8.384a3.48 3.48 0 0 1 3.48-3.48h9.944a3.48 3.48 0 0 1 3.48 3.48v6.78a.768.768 0 1 1-1.537 0v-6.78c0-1.073-.87-1.943-1.943-1.943H7.028c-1.073 0-1.943.87-1.943 1.943v8.136c0 1.073.87 1.943 1.943 1.943h9.944a.768.768 0 0 1 0 1.537H7.028a3.48 3.48 0 0 1-3.48-3.48V8.384Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M20.452 8.384a3.48 3.48 0 0 0-3.48-3.48H7.028a3.48 3.48 0 0 0-3.48 3.48v6.78a.768.768 0 1 0 1.537 0v-6.78c0-1.073.87-1.943 1.943-1.943h9.944c1.073 0 1.943.87 1.943 1.943v8.136c0 1.073-.87 1.943-1.943 1.943H7.028a.768.768 0 1 0 0 1.537h9.944a3.48 3.48 0 0 0 3.48-3.48V8.384Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M6.712 13.356c0 .424.344.768.768.768h.904a.768.768 0 0 0 0-1.536H7.48a.768.768 0 0 0-.768.768ZM14.847 13.356c0 .424.344.768.769.768h.904a.768.768 0 1 0 0-1.536h-.904a.768.768 0 0 0-.769.768ZM10.78 13.356c0 .424.344.768.768.768h.904a.768.768 0 0 0 0-1.536h-.904a.768.768 0 0 0-.768.768Z",
			clipRule: "evenodd"
		})
	]
});
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;
